export const getAccountShortName = (name: string) => {
  return name
    .split(" ")
    .slice(0, 2)
    .map((i) => i.charAt(0))
    .join("");
};
